module.exports = __webpack_public_path__ + "static/media/boletim-de-ocorrencia-text.00a386a7.svg";